<div class="container">
  <h1>{{ isEdit ? 'Edit' : 'Create New' }} Contact</h1>
  
  <mat-card>
    <mat-card-content>
      <form [formGroup]="contactForm" (ngSubmit)="onSubmit()">
        <!-- Basic Information -->
        <div class="form-row">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Category</mat-label>
            <mat-select formControlName="category" required>
              @for (category of categories; track category) {
                <mat-option [value]="category">
                  {{category}}
                </mat-option>
              }
            </mat-select>
            <mat-hint>Select a contact category</mat-hint>
            @if(contactForm.get('category')?.hasError('required')) {
              <mat-error>
                Category is required
              </mat-error>
            }
          </mat-form-field>
        </div>
        
        @if (contactForm.get('category')?.value !== 'Income') {
          <div class="form-row">
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>First Name</mat-label>
              <input matInput formControlName="first_name">
              @if (contactForm.get('category')?.value === 'Insurance') {
                <mat-hint>Enter insured first name</mat-hint>
              } @else if (contactForm.get('category')?.value === 'Self') {
                <mat-hint>Enter your first name</mat-hint>
              } @else {
                <mat-hint>Enter contact's first name</mat-hint>
              }
            </mat-form-field>
          </div>

          <div class="form-row">
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Last Name</mat-label>
              <input matInput formControlName="last_name">
              @if (contactForm.get('category')?.value === 'Insurance') {
                <mat-hint>Enter insured last name</mat-hint>
              } @else if (contactForm.get('category')?.value === 'Self') {
                <mat-hint>Enter your last name</mat-hint>
              } @else {
                <mat-hint>Enter contact's last name</mat-hint>
              }
            </mat-form-field>
          </div>
        }

        @if(contactForm.get('category')?.value === 'Borrower') {
          <div class="form-row">
            ** OR **
          </div>
        }

        @if (contactForm.get('category')?.value !== 'Self') {
          <div class="form-row">
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Organization</mat-label>
              <input matInput formControlName="organization">
              @if (contactForm.get('category')?.value === 'Insurance') {
                <mat-hint>Enter the insurance company name</mat-hint>
              } @else {
                <mat-hint>Enter contact's organization</mat-hint>
              }
            </mat-form-field>
          </div>
        }

        <!-- Form Actions -->
        <div class="button-row">
          <button mat-button type="button" (click)="onCancel()">Cancel</button>
          <button mat-raised-button color="primary" type="submit" [disabled]="!contactForm.valid">
            {{ isEdit ? 'Update' : 'Save' }}
          </button>
        </div>
      </form>
    </mat-card-content>
  </mat-card>
</div>
